export const isNullOrUndefined = value => value === null || typeof value === 'undefined'; // eslint-disable-line no-undefined
